<div
  class="styles-panel-container custom-draggable-glass-panel"
  cdkDrag
  cdkDragRootElement=".cdk-overlay-pane"
  cdkDragHandle>
  <div class="styles-panel-header">
    <h3 class="styles-panel-title">
      <fa-icon
        [icon]="['far', 'layer-group']"
        class="panel-title-icon"></fa-icon>
      {{ 'MAP.SELECT_BACKGROUND' | translate }}
    </h3>

    <button
      mat-icon-button
      aria-label="Close button"
      class="styles-panel-button--close btn-panel-close-icon"
      (click)="onCloseDialog()">
      <mat-icon>close</mat-icon>
    </button>
  </div>

  <mat-selection-list class="styles-panel-selection-list">
    @for (mapLayer of mapLayers; track $index) {
      @let isSelectedLayer =
        mapLayer.name === (selectedLayerStyle$ | async)?.name;

      <mat-list-option
        [selected]="isSelectedLayer"
        (click)="setActiveMapLayer(mapLayer)"
        role="option"
        [class.is-active-layer-item]="isSelectedLayer"
        class="styles-panel-item custom-theme-list-option">
        <img
          class="styles-panel-item-img layer-preview-thumbnail"
          [src]="'/assets/images/map-background/' + mapLayer.name + '.png'"
          matListItemIcon />

        <div class="styles-panel-text-content-wrapper">
          <div class="styles-panel-item-text-h2" matListItemLine>
            {{ 'MAP.' + mapLayer.name + '.TITLE' | translate }}
          </div>
          <p class="styles-panel-item-text-p" matListItemLine>
            {{ 'MAP.' + mapLayer.name + '.DESCRIPTION' | translate }}
          </p>
        </div>
      </mat-list-option>
    }
  </mat-selection-list>
</div>
